import styles from './styles.module.scss';

const Element = (props) => {

    let bck;

    switch(props.background){
        case 0:
        bck = "Blackout";
        break;
        case 1:
        bck = "Dark";
        break;
        case 2:
        bck = "Medium";
        break;
        case 3:
        bck = "Light";
        break;
        case 4:
        bck = "Loreful";
        break;
         case 5:
        bck = "Gartenlore";
        break;
             case 6:
        bck = "Soniarosc";
        break;
               case 7:
        bck = "Creepypast";
        break;
                case 8:
        bck = "Calamities";
        break;
                case 9:
        bck = "Alien";
        break;
                 case 10:
        bck = "Wov";
        break;
                   case 11:
        bck = "Hnia";
        break;
        case 12:
        bck = "KeneBrini";
        break;
    }
    
    return (
        <div className={`${styles['nc-element']} ${props.flexColumn && styles['nc-element--column']} ${styles[`backgroundColor` + bck]} ${props.xmas && styles['backgroundColor' + bck + '--xmas']} ${props.halloween && styles['backgroundColor' + bck + '--halloween']} ${styles[`width--100P`]} ${styles['height--' + props.height]}`}
        >
            {props.children}
        </div>
    );
}


export default Element;